<template>


  <div v-if="show" class="form-group">
    <p>{{ $t('ct-animation') }}</p>

    <!--    <label class="custom-label" style="width: 100%">{{this.type}}</label>-->
    <div class="form">
      <div class="radio">
        <label>
          <input type="radio" name="action" value="time" v-model="action" @change="changeValue" @keyup="changeValue">
          {{ $t('ct-time') }}
        </label>
        <label>
          <input type="radio" name="action" value="scroll" v-model="action" @change="changeValue" @keyup="changeValue">
          {{ $t('ct-when-visible') }}
        </label>
        <label>
          <input type="radio" name="action" value="click" v-model="action" @change="changeValue" @keyup="changeValue">
          {{ $t('ct-click') }}
        </label>
        <label>
          <input type="radio" name="action" value="hover" v-model="action" @change="changeValue" @keyup="changeValue">
          {{ $t('ct-hover') }}
        </label>
      </div>

      <label v-show="action === 'time'">
        {{ $t('ct-timeToStart') }}
        <input type="number" min="0" max="3600" v-model="time" class="custom-input form-control" @change="changeValue"
               @keyup="changeValue">
      </label>

<!--      <label v-show="action === 'scroll'">-->
<!--        Scroll to start-->
<!--        <input type="range" min="0" :max="max" v-model="scroll" class="custom-range" @change="changeValue"-->
<!--               @keyup="changeValue">-->
<!--      </label>-->

      <label style="width: 100%;">
        {{ $t('ct-effect') }}
        <select v-model="effect" class="custom-input form-control" @change="changeValue" @keyup="changeValue">
          <option v-for="option in optionsAll" v-bind:value="option">
            {{ option }}
          </option>
          <option v-for="option in optionsIn" v-bind:value="option">
            {{ option }}
          </option>
			<option v-for="option in optionsOut" v-bind:value="option">
            {{ option }}
          </option>
          <!--          <option v-for="option in (this.type === 'in' ? optionsIn : optionsOut)" v-bind:value="option">-->
          <!--            {{ option }}-->
          <!--          </option>-->
        </select>
      </label>

      <label style="width: 100%;">
        {{ $t('ct-speed') }}
        <select v-model="speed" class="custom-input form-control" @change="changeValue" @keyup="changeValue">
          <option value="slow">Slow</option>
          <option value="slower">slower</option>
          <option value="fast">fast</option>
          <option value="faster">faster</option>
        </select>
      </label>

      <label>
        <input type="checkbox" v-model="infinite" class="custom-checkbox" @change="changeValue" @keyup="changeValue"
               @toggle="changeValue">
        {{ $t('ct-infinite') }}
      </label>
    </div>
	<div class="card shadow-sm preview-animation d-flex justify-content-center align-items-center flex-column">
		<div ref="preview" >
				{{ $t('ct-animation') }}
		</div>
		<button type="button" @click="executePreview()" class="btn btn-outline-primary btn-sm">{{ $t('ct-see-again') }}</button>
	</div>
  </div>
</template>

<script>
	export default {
		name: 'AnimationComponent',
		props: ['type'],
		data() {
			return {
			  callback: () => {},
			  show: true,
				optionsAll: [
					'none',
					'bounce',
					'flash',
					'pulse',
					'rubberBand',
					'shake',
					'headShake',
					'swing',
					'tada',
					'wobble',
					'jello',
					'hinge',
					'jackInTheBox',
					// 'heartBeat',
				],
				optionsIn: [
					'bounceIn',
					'bounceInDown',
					'bounceInLeft',
					'bounceInRight',
					'bounceInUp',
					'fadeIn',
					'fadeInDown',
					'fadeInDownBig',
					'fadeInLeft',
					'fadeInLeftBig',
					'fadeInRight',
					'fadeInRightBig',
					'fadeInUp',
					'fadeInUpBig',
					'flipInX',
					'flipInY',
					'lightSpeedIn',
					'rotateIn',
					'rotateInDownLeft',
					'rotateInDownRight',
					'rotateInUpLeft',
					'rotateInUpRight',
					'rollIn',
					'slideInDown',
					'slideInLeft',
					'slideInRight',
					'slideInUp',
					'zoomIn',
					'zoomInDown',
					'zoomInLeft',
					'zoomInRight',
					'zoomInUp',
				],
				optionsOut: [
					'bounceOut',
					'bounceOutDown',
					'bounceOutLeft',
					'bounceOutRight',
					'bounceOutUp',
					'fadeOut',
					//'fadeOutDown',
					'fadeOutDownBig',
					//'fadeOutLeft',
					'fadeOutLeftBig',
					//'fadeOutRight',
					'fadeOutRightBig',
					//'fadeOutUp',
					'fadeOutUpBig',
					'flipOutX',
					'flipOutY',
					'lightSpeedOut',
					'rotateOut',
					// 'rotateOutDownLeft',
					// 'rotateOutDownRight',
					// 'rotateOutUpLeft',
					// 'rotateOutUpRight',
					'rollOut',
					'slideOutDown',
					'slideOutLeft',
					//'slideOutRight',
					//'slideOutUp',
					'zoomOut',
					'zoomOutDown',
					'zoomOutLeft',
					'zoomOutRight',
					'zoomOutUp'
				],
				element: null,
				action: null,
				effect: null,
				scroll: null,
				time: null,
				speed: null,
				infinite: null,
				max: 2000
			}
		},
		methods: {
			changeValue() {
				let response = {
          action: this.action,
          effect: this.effect,
          scroll: this.scroll,
          time: this.time,
          speed: this.speed,
          infinite: this.infinite
        }

        this.callback(response);
				this.executePreview()
			},

			setValues(obj) {

				this.action = obj.action;
				this.effect = obj.effect;
				this.scroll = obj.scroll;
				this.time = obj.time;
				this.speed = obj.speed;
				this.infinite = obj.infinite;
				this.callback = obj.callback;

				this.max = document.documentElement.scrollHeight;
			},

			executePreview() {
        const pref = window.matchMedia(
          '(prefers-reduced-motion: no-preference)'
        );

        if (!pref.matches) {
          this.$snotify.warning(this.$t('ct-animation-disabled'));
        }

				this.$refs.preview.className = 'animated '+(this.infinite ? 'infinite' : '')
				this.$refs.preview.offsetWidth
				this.$refs.preview.classList.add(this.effect, this.speed)
			}
		},
	}

</script>

<style scoped lang="scss">

  .radio {
    display: inline-grid;
    margin-left: 5px;
    width: 100%;
  }

  html[dir='rtl']{
    .radio {
      padding-right: 5px;
    }
  }

  .form-group {
    overflow: hidden;
  }

  .preview-animation {
	height: 200px;
	width: 100%;
	overflow: hidden;
	div {
		width: 60%;
		height: 60%;
		display: inherit;
		justify-content: inherit;
		align-items: inherit;
		flex-direction: inherit;
		font-size: 1.5rem;
		font-weight: bold;
	}
  }
</style>







// WEBPACK FOOTER //
// src/components/editor/resource_components/Animation.vue